<template>
    <div name="soldoc-app-qrcode" class="soldoc-app-qrcode" id="soldoc-app-qrcode">
        <div class="soldoc-app-qrcode-inner">
            <div class="soldoc-app-area">
                <div class="text-area">
                    <strong>새로운 고객은<br>솔닥이 모셔올게요</strong>
                    <p>원하는 시간에 병원 예약이 가능하므로<br>기다림 없이 진료를 받을 수 있어요.</p>
                </div>
                <div class="img-area">
                    <img src="../../assets/partners_mobile/img_app.gif" alt="솔닥 APP 병원 목록" />
                </div>
            </div>
            <div class="soldoc-qrcode-area">
                <div class="text-area">
                    <strong>한 번 만난 고객<br>두 번은 더 쉽게</strong>
                    <p>원내 비치한 QR 코드로 환자는 언제든<br>우리 병원 진료를 예약할 수 있어요<br>뿐만 아니라 재진 리마인드 알림과 진료 본<br>병원 우선 노출로 재진율을 높여보세요</p>
                </div>
                <div class="img-area">
                    <img src="../../assets/partners_mobile/img_qrcode.gif" alt="솔닥 QR 코드" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-app-qrcode",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {        
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-app-qrcode-inner").offset().top;
            var aniApp = $(".soldoc-app-qrcode .soldoc-app-area");
            var aniQrcode = $(".soldoc-app-qrcode .soldoc-qrcode-area");

            if (height <= 0) {
                $(aniApp).removeClass('item-show').addClass('item-hide');
                $(aniQrcode).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1500) {
                $(aniApp).removeClass('item-hide').addClass('item-show');
                $(aniQrcode).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1500) {
                $(aniApp).removeClass('item-show').addClass('item-hide');
                $(aniQrcode).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-app-qrcode {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 1429px;
    background: #F3F4F7;
    overflow: hidden;
}
.soldoc-app-qrcode-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 31px;
    width: 100%;
    margin: 0 auto;
    padding: 103px 5px;
}
.soldoc-app-qrcode .soldoc-app-qrcode-inner > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 346px;
    height: auto;
    border-radius: 20px;
    padding: 50px 39px 0 39px;
}
.soldoc-app-qrcode .soldoc-app-area {
    background: #FFF;
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode .soldoc-qrcode-area {
    background: #1A1F27;    
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode.item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode .soldoc-app-area.item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-app-qrcode .soldoc-qrcode-area.item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp2 2s;
}
.soldoc-app-qrcode .text-area strong {
    display: inline-block;
    font-size: 26px;
    font-weight: 600;
    line-height: 36px;
    color: #1A1A1A;
}
.soldoc-app-qrcode .soldoc-qrcode-area .text-area strong,
.soldoc-app-qrcode .soldoc-qrcode-area .text-area p {
    color: #FFF;
}
.soldoc-app-qrcode .text-area p {
    margin-bottom: 0;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #1A1A1A;
}
.soldoc-app-qrcode .soldoc-app-area .img-area {
    width: 100%;
    max-width: 267px;
    height: auto;
    margin: 84px auto 0;
    overflow: hidden;
}
.soldoc-app-qrcode .soldoc-app-area .img-area img {
    width: 100%;
}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area {
    position: relative;
    width: 265px;
    height: 283px;
    margin: 69px auto 0;
    overflow: hidden;
    margin-left: 50%;
    transform: translateX(-50%);
}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 50;
    width: 100%;
    height: 100%;
}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 204px;
    height: 283px;
    background: url(../../assets/partners_mobile/img_qrcode.png) 0 0 no-repeat;
    background-size: auto 283px;
}

@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}

@media screen and (max-width: 359px) {
    .soldoc-app-qrcode {
        height: auto;
    }
    .soldoc-app-qrcode-inner {
        padding: 103px 20px;
    }
    .soldoc-app-qrcode .soldoc-app-qrcode-inner > div {
        width: 100%;
        height: auto;
        padding: 30px 19px 0 19px;
    }
    .soldoc-app-qrcode .text-area strong {
        font-size: 24px;
        line-height: 34px;
    }
    .soldoc-app-qrcode .text-area p {
        font-size: 14px;
        line-height: 24px;
    }
    .soldoc-app-qrcode .soldoc-app-area .img-area {
        width: 213.6px;
        height: auto;
        margin: 44px auto 0;
    }
    .soldoc-app-qrcode .soldoc-qrcode-area .img-area {
        width: 212px;
        height: 226.4px;
        margin: 44px auto 0;
        margin-left: 50%;
        transform: translateX(-50%);
    }
    .soldoc-app-qrcode .soldoc-qrcode-area .img-area img {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 50;
        width: 100%;
        height: 100%;
    }
    .soldoc-app-qrcode .soldoc-qrcode-area .img-area::before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 163.2px;
        height: 226.4px;
        background: url(../../assets/partners_mobile/img_qrcode.png) 0 0 no-repeat;
        background-size: auto 226.4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/SoldocAppQrcode.vue